import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18207 18208"
    {...props}
  >
    <defs>
      <style>
        {
          ".str0{stroke:#000;stroke-width:516.548}.fil1{fill:none}.fil0{fill:#1c1b17}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974593127152">
        <path
          d="M15648 1814c-324 59-595 348-524 753 56 316 359 584 752 516 318-56 585-363 517-753-55-317-358-586-745-516z"
          className="fill stroke1"
          style={{
            strokeWidth: 516.548,
          }}
        />
        <path
          d="M9021 6358c-89 0-94 26-147-36-140-161-373-652-441-862-277-849-220-1655 128-2462 84-196 472-829 598-868 159-49 1036 92 1274 138 400 77 782 196 1136 336 316 125 720 312 988 482 202 129 750 469 863 614-49 29-111 35-165 47-332 70-668 210-960 361-655 339-1173 865-1545 1489-157 264-372 746-427 1084-436-143-578-321-1302-323zM7597 9141c-13-215 36-431 106-603 60-148 167-320 278-436 21-23 65-67 90-86 113-85 149-134 321-217 574-279 1184-138 1607 240 105 94 240 285 301 412 258 532 172 1100-195 1550-67 83-142 158-229 220-65 47-146 97-227 137-510 255-1116 172-1550-194-253-215-475-546-502-1023z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 516.548,
          }}
        />
        <path
          d="M1631 355c-560 86-1023 441-1210 978-146 422-86 1584-86 2113v12060c0 322-26 783 17 1083 82 582 506 1032 981 1198 422 146 1585 86 2113 86h12060c318 0 786 27 1086-17 580-86 1028-500 1195-981 145-421 85-1584 85-2113l1-12060c0-323 26-779-18-1086-84-583-497-1018-980-1195-398-145-1606-86-2113-87l-12060 1c-319 0-777-25-1071 20z"
          className="fill-none stroke1"
          style={{
            stroke: "#000",
            strokeWidth: 645.685,
          }}
        />
        <path
          d="M15637 15126c-102 21-157 40-234 92-68 45-122 93-164 153-343 490 60 1132 647 1018 313-60 582-372 503-760-62-304-355-584-752-503zM2339 1817c-324 59-595 348-524 753 56 316 360 584 753 515 317-55 584-362 517-752-55-317-359-586-746-516zM2758 16315c41-5 22 1 64-27 20-13 39-28 53-40 472-405 137-1254-554-1123-189 36-402 191-442 338-146 153-123 828 453 929 135 23 350 9 426-77z"
          className="fill stroke1"
          style={{
            strokeWidth: 516.548,
          }}
        />
        <path
          d="M6665 7719c-45 77-25 95-105 110-210 40-751-4-966-50-875-185-1544-636-2069-1342-127-171-482-823-452-952 37-162 597-851 756-1034 266-308 560-579 859-816 266-211 631-468 912-614 212-111 781-416 962-440 1 56-24 113-41 166-105 323-152 683-167 1012-35 737 162 1448 517 2082 149 268 459 695 725 912-342 306-567 339-931 966zM6666 10440c44 77 69 68 42 145-70 202-379 649-526 813-597 664-1323 1018-2196 1120-212 25-955 6-1051-84-122-113-438-943-518-1173-133-384-221-774-277-1151-50-336-89-780-76-1096 10-240 31-885 100-1055 50 28 86 79 123 120 227 252 516 473 793 650 621 398 1336 584 2062 594 307 4 832-51 1152-173 95 450 11 661 372 1290zM9023 11800c88 0 93-26 146 35 140 162 373 653 441 862 277 850 220 1656-128 2462-84 196-472 830-598 868-159 50-1036-92-1274-137-400-77-781-196-1136-336-316-125-720-313-987-483-203-128-751-468-864-613 49-30 111-36 165-47 332-71 668-211 960-362 655-339 1173-865 1545-1489 157-263 372-745 427-1083 436 142 578 321 1303 323zM11377 7718c-44-77-69-69-42-145 70-203 379-649 526-813 597-664 1323-1018 2196-1120 212-25 955-6 1051 84 122 113 438 943 518 1172 133 385 221 774 277 1151 50 337 89 781 76 1097-10 240-31 885-100 1054-50-27-86-78-123-119-227-252-516-473-793-650-621-399-1336-584-2062-594-307-5-832 51-1152 172-95-449-11-661-372-1289zM11378 10438c45-76 25-94 105-109 210-40 751 4 966 49 875 185 1544 637 2069 1342 127 171 482 824 452 952-37 162-597 851-756 1035-266 308-560 579-858 815-267 212-632 468-913 615-212 111-781 415-962 440-1-57 24-114 41-166 105-323 152-683 167-1012 35-737-162-1449-516-2083-150-267-460-694-726-911 342-306 567-340 931-967z"
          className="fill-none stroke1"
          style={{
            strokeWidth: 516.548,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
